(function () {
  if (customElements.get('shop-tour')) return;

  class ShopTour extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.shop-tour__dialog');
      this.inner = this.querySelector('.shop-tour__dialog-inner');
      this.embed = this.querySelector('[data-shop-tour-embed]');
      this.openButtons = this.querySelectorAll('[data-shop-tour-open]');
      this.closeButtons = this.querySelectorAll('[data-shop-tour-close]');
      this.tourSrc = this.getAttribute('data-tour-src') || '';
      this.tourTitle = this.getAttribute('data-tour-title') || 'Guided tour';
      this.onOpen = this.open.bind(this);
      this.onClose = this.close.bind(this);
      this.onWarm = this.loadTour.bind(this);
      this.onDialogClick = this.onBackdropClick.bind(this);
      this.onKeyDown = this.onEscape.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);

      this.openButtons.forEach((button) => {
        button.addEventListener('click', this.onOpen);
        button.addEventListener('pointerenter', this.onWarm);
        button.addEventListener('focus', this.onWarm);
      });
      this.closeButtons.forEach((button) => button.addEventListener('click', this.onClose));

      if (this.dialog) {
        this.dialog.addEventListener('click', this.onDialogClick);
        this.dialog.addEventListener('keydown', this.onKeyDown);
        this.dialog.addEventListener('close', this.onDialogClose);
      }
    }

    disconnectedCallback() {
      this.openButtons?.forEach((button) => {
        button.removeEventListener('click', this.onOpen);
        button.removeEventListener('pointerenter', this.onWarm);
        button.removeEventListener('focus', this.onWarm);
      });
      this.closeButtons?.forEach((button) => button.removeEventListener('click', this.onClose));
      this.dialog?.removeEventListener('click', this.onDialogClick);
      this.dialog?.removeEventListener('keydown', this.onKeyDown);
      this.dialog?.removeEventListener('close', this.onDialogClose);
      this.unloadTour();
    }

    open(event) {
      event.preventDefault();
      if (!this.dialog || !this.tourSrc) return;

      this.loadTour();

      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }

      document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
      this.querySelector('[data-shop-tour-close]')?.focus();
    }

    close(event) {
      if (event) event.preventDefault();
      if (!this.dialog) return;

      if (typeof this.dialog.close === 'function' && this.dialog.open) {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }

      this.unlockScroll();
      this.querySelector('[data-shop-tour-open]')?.focus();
    }

    onDialogClose() {
      this.unlockScroll();
    }

    onBackdropClick(event) {
      if (event.target === this.dialog) this.close(event);
    }

    onEscape(event) {
      if (event.code === 'Escape') {
        event.preventDefault();
        this.close(event);
      }
    }

    loadTour() {
      if (!this.embed || !this.tourSrc) return;

      const existing = this.embed.querySelector('iframe');
      if (existing) return;

      this.inner?.classList.remove('is-loaded');
      this.dialog?.setAttribute('aria-busy', 'true');

      const iframe = document.createElement('iframe');
      iframe.src = this.tourSrc;
      iframe.title = this.tourTitle;
      iframe.setAttribute('name', 'iframe');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute(
        'allow',
        'accelerometer; gyroscope; xr-spatial-tracking; fullscreen; autoplay'
      );
      iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      iframe.addEventListener('load', () => this.markLoaded(), { once: true });
      this.embed.appendChild(iframe);
    }

    markLoaded() {
      this.inner?.classList.add('is-loaded');
      this.dialog?.setAttribute('aria-busy', 'false');
    }

    unloadTour() {
      this.embed && (this.embed.innerHTML = '');
      this.inner?.classList.remove('is-loaded');
      this.dialog?.removeAttribute('aria-busy');
    }

    unlockScroll() {
      if (!document.querySelector('dialog[open]')) {
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      }
    }
  }

  customElements.define('shop-tour', ShopTour);
})();
